/* eslint-disable */


/**
 * Create styles for `<OrderTime />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderTime />` styles
 */
const orderTimeStyles = ({ theme }) => ({
  dateTimeLabel: {
    paddingLeft: `4px`,
  },
  timeContainer: {
    minWidth: 84,
  },
});

export default orderTimeStyles;
